import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { WageBase } from '../../../models/wage-base';

import { NotyService } from '../../../services/common/noty.service';
import { WageBaseService } from '../../../services/users/wage-base.service';

declare var swal: any;

@Component({
  selector: 'app-wage-base-index',
  templateUrl: './wage-base-index.component.html',
  styleUrls: ['./wage-base-index.component.scss'],
})
export class WageBaseIndexComponent implements OnInit {
  @Input() userId: number;

  deletingWageBase: boolean = false;

  loading: boolean = false;

  modalRef: BsModalRef;

  saving: boolean = false;

  selectedWageBase: WageBase;

  wageBases: Array<WageBase> = [];

  @ViewChild('wageBaseForm', { static: true }) wageBaseFormTemplate: TemplateRef<any>;
  @ViewChild('wageBaseShow', { static: true }) wageBaseShowTemplate: TemplateRef<any>;

  constructor(private modalService: BsModalService, private notyService: NotyService, private wageBaseService: WageBaseService) {}

  // Component life cycle events
  ngOnInit() {
    this.loadWageBases();
  }

  // Component methods
  addNewWageBase() {
    this.selectedWageBase = new WageBase();
    this.selectedWageBase.user_id = this.userId;
    this.openModal(this.wageBaseFormTemplate);
  }

  deleteWageBase(wageBase: WageBase) {
    let scope: WageBaseIndexComponent = this;
    swal({
      title: 'Delete Wage Base',
      text: `Delete Wage Base ${wageBase.id} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed) {
          this.deletingWageBase = true;
          this.wageBaseService
            .delete(wageBase.id)
            .then((response) => {
              this.deletingWageBase = false;
              if (response.success) {
                this.notyService.notify(response.text || `Deleted wage base ${wageBase.id}`, 'warning');
                this.loadWageBases();
              } else {
                this.notyService.notify(response.text || 'Error deleting wage base', 'error');
              }
            })
            .catch(() => {
              scope.deletingWageBase = false;
              scope.notyService.notify('Error deleting wage base', 'error');
            });
        }
      })
      .catch((err: any) => {
        console.log('Delete prompt error', err);
      });
  }

  editWageBase(wageBase: WageBase) {
    this.wageBaseService.edit(wageBase.id).then((response_json) => {
      this.selectedWageBase = response_json.wage_base;
      this.openModal(this.wageBaseFormTemplate);
    });
  }

  loadWageBases() {
    this.wageBaseService.index({ user_id: this.userId }).then((response_json) => {
      this.loading = false;
      this.wageBases = response_json.wage_bases;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  save() {
    this.saving = true;
    if (this.selectedWageBase && this.selectedWageBase.effective_date_struct && this.selectedWageBase.effective_date_struct.year)
      this.selectedWageBase.effective_date = `${this.selectedWageBase.effective_date_struct.year}-${this.selectedWageBase.effective_date_struct.month}-${this.selectedWageBase.effective_date_struct.day}`;
    this.wageBaseService
      .save(this.selectedWageBase)
      .then((response_json) => {
        this.saving = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Wage base saved', 'success');
          this.loadWageBases();
          this.modalRef.hide();
        } else this.notyService.notify(response_json.text || 'Error saving wage base', 'error');
      })
      .catch(() => {
        this.saving = false;
        this.notyService.notify('Error saving wage base', 'error');
      });
  }

  showWageBase(wageBase: WageBase) {
    this.selectedWageBase = wageBase;
    this.openModal(this.wageBaseShowTemplate);
  }
}
